export default __webpack_public_path__ + "static/media/HeroImg_Web.d791e8d5.png";